
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'VaginalCancer_FIGO',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/VaginalCancer_FIGO.vue